import { useContext, useEffect, useState } from "react";
import { useGetInfo } from "antopolis-react-utils/hooks";
import Form from "../../../Partials/Forms/Form";
import ImageInput from "../../../Partials/Forms/FormInputs/ImageInput/ImageInput";
import ShortTextInput from "../../../Partials/Forms/FormInputs/ShortTextInput/ShortTextInput";
import LongTextInput from "../../../Partials/Forms/FormInputs/LongTextInput/LongTextInput";
import FormSubmitButton from "../../../Partials/Forms/FormSubmitButton/FormSubmitButton";
import { useAxiosInstance } from "../../../../Utilities/Hooks/useAxiosInstance";
import FilterSelect from "../../../Partials/Forms/FilterSelect/FilterSelect";

function UpdateService({ api, setShowUpdateForm, targetID, triggerFetch }) {
  const [image, setImage] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [isActive, setIsActive] = useState('active');

  // const { triggerFetch } = useContext(LayoutContext)
  const axiosInstance = useAxiosInstance();

  const { info: service } = useGetInfo({
    axiosInstance: axiosInstance,
    api: api + "/" + targetID,
  });

  useEffect(() => {
    if (service) {
      setImage(service.image);
      setTitle(service.title);
      setDescription(service.description);
      setIsActive(service.isActive == true ? 'active' : 'archive');
    }
  }, [service]);

  async function handleSubmit(e) {
    e.preventDefault();

    const itemData = new FormData();
    itemData.append("title", title);
    itemData.append("image", image);
    itemData.append("description", description);
    itemData.append("isActive", isActive);

    const response = await axiosInstance.patch(api + "/" + targetID, itemData);
    console.log(response,'res')
    if (response) {
      triggerFetch();
      setShowUpdateForm(false);
    }
  }
  return (
    <div className="crate_form">
      <Form onSubmit={handleSubmit}>
        <ImageInput
          fieldId="1"
          state={image}
          setState={setImage}
          allowUpdateImage
        >
          Upload Image
        </ImageInput>

        <ShortTextInput label={"title"} value={title} setState={setTitle} />
        <LongTextInput
          label={"description"}
          value={description}
          setState={setDescription}
        />

        <FormSubmitButton text="Update service" />
        <FilterSelect filter={isActive} setFilter={setIsActive}/>
      </Form>
    </div>
  );
}

export default UpdateService;